module.exports = __webpack_public_path__ + "static/Beckers-662816832fdfaf3d50fd0639b6cc4152.png";